import { _, ref, storage, App } from '@zto/zpage'

// 10秒钟内只能请求一次
const RequestDuration = 20000

// 兔喜组织缓存key
const TuxiOrgsKey = 'areaOrg'

let __lastRequestTime: number | null = null

let __orgs = ref<any[]>([])

let __flatten_orgs_map: Record<string, string> = {}

export const orgSeparator = '---'

// 默认区域组织组件属性
export const DefaultAreaOrgProps = ['largeDeptCode', 'provinceDeptCode', 'cityDeptCode']
export const DefaultAreaOrgLabelProps = ['largeDeptName', 'provinceDeptName', 'cityDeptName']
export const DefaultAreaOrgApiParamsMap = Object.freeze(
  DefaultAreaOrgProps.reduce((acc, cur) => {
    acc[cur] = cur
    return acc
  }, {} as Record<string, string>)
)

export const DefaultServiceProviderProp = 'serviceProviderCode'

export function getOrgsRef() {
  return __orgs
}

/** 获取组织列表 */
let __loading = false
export async function loadOrgs(app: App) {
  const appApi = app.api

  if (__orgs.value?.length || !appApi?.getCityDeptTree) return __orgs

  if (__loading) return __orgs

  try {
    __loading = true

    // 防止报错
    let data = storage.page.get(TuxiOrgsKey) || []

    if (!data?.length) {
      // 防止过去频繁请求接口，导致应用卡死卡死
      if (!__lastRequestTime || new Date().getTime() - __lastRequestTime > RequestDuration) {
        __lastRequestTime = new Date().getTime()

        data = await appApi!.getCityDeptTree()
        console.log('data===', data)
        storage.page.set(TuxiOrgsKey, data)
      }
    }

    __orgs.value = normalizeOrgs(data)
    __loading = false
  } catch (ex) {
    __loading = false
    console.error(ex)
  }

  return __orgs
}

// 解析组织值
export function getOrgData(val: string) {
  if (!val) return []
  return __flatten_orgs_map[val]
}

// 格式化区域
function normalizeOrgs(data: any): any[] {
  if (!data || !Array.isArray(data)) return []

  data.forEach(it => {
    if (!it) return
    it.label = it.text
    it.value = String(it.value)
    __flatten_orgs_map[it.value] = _.omit(it, ['children'])

    normalizeOrgs(it.children)
  })

  return data
}
